import { cn } from '#app/utils/misc'

const ColorCheckbox = ({
	color,
	checked,
	id,
}: {
	color: string
	checked: boolean
	id: string
}) => {
	// Conditional styling for white color
	const checkboxStyle = color === '#FFFFFF' ? 'border border-beige-90' : ''
	const checkmarkColor = color === '#FFFFFF' ? 'black' : 'white' // Choose color for the checkmark

	return (
		<div
			className={cn(
				`relative h-6 w-6 cursor-pointer rounded-md`,
				checked ? 'bg-blue-500' : '',
				checkboxStyle,
			)}
			style={{ backgroundColor: color }}
			id={id}
		>
			{checked && (
				<svg viewBox="0 0 10 10" width="24" height="22">
					{/* Adjust viewBox dimensions */}
					<path
						d="M2,5 L4,7 L8,3"
						stroke={checkmarkColor}
						strokeWidth="1.5"
						fill="none"
					/>
				</svg>
			)}
		</div>
	)
}

ColorCheckbox.displayName = 'ColorCheckbox'

export { ColorCheckbox }
